import type { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { EnvironmentService } from '@core/services/environment.service';

/**
 * Wraps a functional HttpInterceptorFn so it only runs for requests targeting
 * the AML Desk platform domain. Non-matching requests bypass the interceptor entirely.
 *
 * @param {HttpInterceptorFn} interceptor - The functional interceptor to guard with the ADP host check.
 * @returns {HttpInterceptorFn} A functional interceptor that delegates to the wrapped interceptor only for ADP-host requests.
 */
export const adpScopedInterceptor = (interceptor: HttpInterceptorFn): HttpInterceptorFn => {
  return (request, next) => {
    const environmentService = inject(EnvironmentService);

    return request.url.includes(environmentService.baseAdpHost) ? interceptor(request, next) : next(request);
  };
};
